import { listMyProfiles } from '@/api/auth';
import { ssoCheckLoginStatus } from '@/api/auth/sso';
import api from '@/api';
import { roles } from '@/data/constants';

const state = {
  allowedRoles: ['admin', 'bn.master', 'bn.cashier'], //[Check] vary by projects
  mustLogin: true,
  user: null,
  profile: null,
  profiles: [],
  /** @type {Boolean | Error} */
  loginBlocked: false,
  accessToken: null,
  impersonatedToken: null,
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setProfile(state, profile) {
    state.profile = profile;
  },
  setProfiles(state, profiles) {
    state.profiles = Array.isArray(profiles) ? profiles : [];
  },
  setLoginBlocked(state, blocked) {
    state.loginBlocked = blocked;
  },
  setAccessToken(state, token) {
    state.accessToken = token;
    // Store in localStorage for persistence
    if (token) {
      localStorage.setItem('accessToken', token);
    } else {
      localStorage.removeItem('accessToken');
    }
  },
  setImpersonatedToken(state, token) {
    state.impersonatedToken = token;
  },
  // Initialize token from localStorage on app start
  initializeToken(state) {
    const token = localStorage.getItem('accessToken');
    if (token) {
      state.accessToken = token;
    }
  },
};

const actions = {
  async checkLoginStatus({ commit, state, dispatch }) {
    try {
      const data = await ssoCheckLoginStatus(api);
      commit('setUser', data.user);
      commit('setProfile', data.profile);
      if (!data.user && state.mustLogin) {
        throw new Error('mustLogin');
      }
      if (data.profile && !state.allowedRoles.includes(data.profile.role)) {
        throw new Error('allowedRoles');
      }
      // Temporarily not used in the project, comment to avoid fetching errors
      // try {
      //   if (data.user && data.profile.role !== roles.master) {
      //     commit('setProfiles', (await listMyProfiles(api, { limit: 50 })).docs);
      //   } else {
      //     commit('setProfiles', []);
      //   }
      // } catch (e) {
      //   commit('setProfiles', []);
      //   // console.log(e);
      // }
      return data;
    } catch (e) {
      throw e;
    }
  },
  async login({ commit }, loginData) {
    // Store the access token from login response
    if (loginData.accessToken && loginData.accessToken.token) {
      commit('setAccessToken', loginData.accessToken.token);
    }
    commit('setUser', loginData.user);
    commit('setProfile', loginData.profile);
  },
  async logout({ commit }) {
    // Clear all auth data
    commit('setUser', null);
    commit('setProfile', null);
    commit('setProfiles', []);
    commit('setAccessToken', null);
    commit('setImpersonatedToken', null);
  },
  initializeAuth({ commit }) {
    // Initialize token from localStorage on app startup
    commit('initializeToken');
  },
};

const getters = {
  user: state => state.user,
  profile: state => state.profile,
  profiles: state => state.profiles,
  userId: state => state.user && state.user._id,
  profileId: state => state.profile && state.profile._id,
  role: state => state.profile && state.profile.role,
  isAdmin: (state, getters) => getters.role === 'admin',
  isMaster: (state, getters) => getters.role === 'bn.master',
  isCashier: (state, getters) => getters.role === 'bn.cashier',
  // isAgent: (state, getters) => getters.role === 'agent',
  // isManager: (state, getters) => getters.role === 'manager',
  isLoggedIn: state => !!state.user,
  loginBlocked: state => state.loginBlocked,
  accessToken: state => state.accessToken,
  impersonatedToken: state => state.impersonatedToken,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
